import axios from "axios";

export const GET_CATEGORIES_PRODUCTS = "GET_CATEGORIES_PRODUCTS";

export const getCategoriesProduct = () => {
  return async (dispatch) => {
    return await axios
      .get(process.env.REACT_APP_SERVER_URL + `/api/CatEtSsCat/allcatetsscat`)
      .then((res) => {
        dispatch({ type: GET_CATEGORIES_PRODUCTS, payload: res.data });
      })
      .catch((err) => console.log(err));
  };
};
